type DialogState = {
  message: string;
  title: string;
  resolve: () => void;
} | null;

export const useDialog = () => {
  const dialogState = useState<DialogState>('dialog-state', () => null);

  /**
   * ダイアログを出し、**閉じられるまで待つ**。
   *
   * **出す前に必ずローディングを畳む。** この Promise は `close()` が呼ばれるまで解決しないので、
   * 呼び出し側が `try { await show(...) } finally { stopLoading() }` の形で書いていると、
   * ダイアログの裏でローディングが回り続ける。しかも
   * `layouts/default.vue` の `.loading-overlay` は **`z-index: 9999` ＋ 白 80% の全画面**で、
   * Element Plus の `el-dialog`（既定 2000 台）より前面に出る。結果として
   * **エラー文がうっすら見えるだけで「閉じる」が押せず、ESC でしか閉じられない**状態になっていた。
   *
   * 畳む責任を呼び出し側に置くと、ダイアログを足すたびに同じ事故が起きる（実際に3箇所で起きていた）。
   * **ダイアログは「ユーザーの応答を待つ」ものなので、ローディングとは同時に出したい場面が無い。**
   * ここで一括して畳む。
   */
  const show = async (message: string, title: string) => {
    useLoadingState().stopLoading();

    return new Promise<void>((resolve) => {
      dialogState.value = { message, title, resolve };
    });
  }

  const showAfterRoute = async (message: string, title: string, route: string) => {
    await navigateTo(route);
    await nextTick();
    return show(message, title);
  }

  const close = () => {
    dialogState.value?.resolve();
    dialogState.value = null;
  }

  return {
    dialogState: readonly(dialogState),
    show,
    showAfterRoute,
    close,
  };
}
